import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { DialogData } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-pallet-customers',
  templateUrl: './edit-pallet-customers.component.html',
  styleUrls: ['./edit-pallet-customers.component.css']
})
export class EditPalletCustomersComponent implements OnInit {
	labelResponse='';
	viewBtn=true;
	PlaceOrderCustomer=[];
	ArrayLocations=[];
	FormPallets:FormGroup;
	@ViewChild('locations') locationsSelect: MatSelect
	  onNoClick(): void {
		this.dialogRef.close();
	  }
  constructor(private formbuilder:FormBuilder  ,private authenticationService:AuthenticationService ,private _httpClient:HttpClient,public dialogRef: MatDialogRef<EditPalletCustomersComponent>,
	@Inject(MAT_DIALOG_DATA) public data: any) {
	this.PlaceOrderCustomer=[];
this.ArrayLocations=[];
this.OnSelectCostumer();
this.OnSelectLocations('');
   }

  ngOnInit(): void {
	this.FormPallets=this.formbuilder.group({
location:[""],
customer:[""]

	})

	this.FormPallets.controls.customer.setValue(this.data.tblcustomerID)
	//this.FormPallets.controls.location.setValue(this.data.tblcustomerID)

  }
  OnSelectCostumer() {
	var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

	var Request = {};
	Request['companyId'] = json.companyIdWh;
	Request['active'] = '1';

	this._httpClient
	  .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
		headers: new HttpHeaders({
		  'Access-Control-Allow-Origin': '*',
		  'Access-Control-Allow-Headers': '*',
		  'Access-Control-Allow-Methods': '*',
		  Authorization: 'Bearer ' + json.token,
		}),
	  })
	  .subscribe((response: any) => {
		this.PlaceOrderCustomer = response;
	  });
  }
  OnSelectLocations(seaarch:any) {
	var ss=String(seaarch)
if (ss=='') {
	

	this._httpClient
	  .get<any>(
		`${environment.apiUrl}/Administracion/SearchLocationsNew?companyId=${Number(this.authenticationService.currentUserValue.companyIdWh)}&active=1&search=${String(seaarch)}`,
		
		{
		  headers: new HttpHeaders({
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Headers': '*',
			'Access-Control-Allow-Methods': '*',
			Authorization:
			  'Bearer ' + this.authenticationService.currentUserValue.token,
		  }),
		}
	  )
	  .subscribe((response: any) => {
		this.ArrayLocations = response;
		try {
				this.FormPallets.controls.location.setValue(this.ArrayLocations[0].id)
		} catch (error) {
			
		}
	  });
	} else {
	if (ss.length>3) {
		this._httpClient
	  .get<any>(
		`${environment.apiUrl}/Administracion/SearchLocationsNew?companyId=${Number(this.authenticationService.currentUserValue.companyIdWh)}&active=1&search=${String(seaarch)}`,
		
		{
		  headers: new HttpHeaders({
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Headers': '*',
			'Access-Control-Allow-Methods': '*',
			Authorization:
			  'Bearer ' + this.authenticationService.currentUserValue.token,
		  }),
		}
	  )
	  .subscribe((response: any) => {
		this.ArrayLocations = response;
		this.locationsSelect.open()
	  });
	} else {
		
	}
	}
  }
  applyFilterLocation (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
  
this.OnSelectLocations(filterValue.trim().toLowerCase())
   
  }
  OnSaveUpdatePalletCustomers() {
	this.viewBtn=false;
	var Request = {

		receiveProductsId:Number(this.data.ID),
		company:Number(this.authenticationService.currentUserValue.companyIdWh),
		customerIdNew:Number(this.FormPallets.controls.customer.value),
		locationIdNew:Number(this.FormPallets.controls.location.value)

	};


	this._httpClient
	  .post<any>(
		`${environment.apiUrl}/Receive/ReceiveUpdateCustomerPallets`,
		Request,
		{
		  headers: new HttpHeaders({
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Headers': '*',
			'Access-Control-Allow-Methods': '*',
			Authorization:
			  'Bearer ' + this.authenticationService.currentUserValue.token,
		  }),
		}
	  )
	  .subscribe((response: any) => {
		try {
			this.labelResponse=response.responses;
		} catch (error) {
			
		}
		//this.onNoClick();
	  });
  }
}
